import React, { useMemo, useContext } from "react";
import PersonelsList from "features/users/personel/PersonelsList";
import DriversList from "features/users/driver/DriversList";
import ParentsList from "features/users/parent/ParentsList";
import StudentsList from "features/users/student/StudentsList";

import { AuthContext } from "shared/context/auth-context";

import { useTranslation } from "react-i18next";
import { PERMISSION_TYPES } from "@routebot/constants";
import { useSearchParams } from "react-router-dom";

import Tabs from "components/ui/tabs/Tabs";
import { resolveTabIndexFromQuery } from "pages/shared/utility";

const UsersPage = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const [searchParams] = useSearchParams();

  const usersPageTabs = useMemo(() => {
    let allTabs = [];

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS]) {
      allTabs.push({
        id: "personels",
        label: t("employees"),
        content: <PersonelsList />,
      });
    }

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) {
      allTabs.push({
        id: "parents",
        label: t("parents"),
        content: <ParentsList />,
      });
    }

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) {
      allTabs.push({
        id: "students",
        label: t("students"),
        content: <StudentsList />,
      });
    }

    allTabs.push({
      id: "drivers",
      label: t("drivers"),
      content: <DriversList />,
    });

    return allTabs;
  }, [t, auth.permissions]);

  const tabParam = searchParams.get("tab");
  const initialTabIndex = resolveTabIndexFromQuery(tabParam, usersPageTabs);

  return <Tabs tabs={usersPageTabs} isVertical={true} id="users-page" initialTabIndex={initialTabIndex} />;
};

export default UsersPage;
